// extracted by mini-css-extract-plugin
export default {"main":"SeriesBlog_main__JJGy4","inner":"SeriesBlog_inner__ljqj9","span":"SeriesBlog_span__sSjJr","icon":"SeriesBlog_icon__wElBj","heading":"SeriesBlog_heading__ufxnX"};